import { UtimacoCircuitSwitch } from './utimacoCircuitSwitch.types';

// eslint-disable-next-line import/prefer-default-export
export function adaptToCreate(
  data: UtimacoCircuitSwitch,
): UtimacoCircuitSwitch {
  return {
    CFID: data.CFID,
    AFID: data.AFID,
    ISDN: data.ISDN,
    LEA: data.LEA,
    CCCMCID: data.CCCMCID ?? '',
    CUGILC: data.CUGILC ?? '',
    CUGDNIC: data.CUGDNIC ?? '',
    CPRISDN: data.CPRISDN ?? '',
  };
}
